/**
 * Filtra itens de novidades que são metadados de versão ou manutenção interna,
 * não mudanças visíveis para o usuário final.
 */

const RELEASE_META_PATTERNS = [
  /\batualiza(?:ção)?\s+(?:de\s+)?release\s*notes\b/i,
  /\brelease\s*notes\s+(?:para|da|do|de)\b/i,
  /\batualiza\s+dados\s+da\s+central\s+de\s+ajuda\b/i,
  /\batualiza\s+índices\s+da\s+central\s+de\s+ajuda\b/i,
  /\bhelp-center-index\b/i,
  /\bsync-app-version\b/i,
  /\bappversion\.generated\b/i,
  /\bupdate-release-notes\b/i,
  /\bgenerate-release-notes\b/i,
  /\bhumaniza(?:r)?\s+(?:a\s+)?central\s+de\s+ajuda\b/i,
  /\bcentral\s+de\s+ajuda\s+e\s+novidades\s+atualizadas\b/i,
  /\bcentral\s+de\s+ajuda\s+ampliada\b/i,
  /\bcentral\s+de\s+ajuda\s+com\s+linguagem\s+mais\s+simples\b/i,
  /\bíndice\s+da\s+central\s+de\s+ajuda\b/i,
  /\btextos\s+da\s+central\s+de\s+ajuda\s+revisados\b/i,
  /\bcentral\s+de\s+ajuda\s+revisada\b/i,
  /\bplatform-knowledge\b/i,
];

/** Commit ou texto humanizado que é só número de versão (ex.: 4.0.168, 4.0.4.0.168). */
export function isVersionBumpMessage(message) {
  const m = String(message || "")
    .trim()
    .replace(/\.+$/, "");
  if (!m) return false;
  if (/^\d+(\.\d+)+$/.test(m)) return true;
  if (/^v\d+(\.\d+)+$/i.test(m)) return true;
  return false;
}

export function isInternalReleaseChange(message) {
  const m = String(message || "").trim();
  if (!m) return true;
  if (isVersionBumpMessage(m)) return true;
  return RELEASE_META_PATTERNS.some((re) => re.test(m));
}

export function filterUserFacingReleaseChanges(changes) {
  return (changes || []).filter((change) => !isInternalReleaseChange(change?.message));
}

export function filterUserFacingReleaseVersions(versions) {
  return (versions || [])
    .map((version) => ({
      ...version,
      changes: filterUserFacingReleaseChanges(version.changes),
    }))
    .filter((version) => (version.changes || []).length > 0);
}
